import React, { useState, useRef, useEffect } from 'react';
import { Box, Typography, Button, Dialog, DialogContent } from '@mui/material';

const WhiteboardNote = ({ notes }) => {
    const [showFullText, setShowFullText] = useState(false);
    const [isTruncated, setIsTruncated] = useState(false);
    const textRef = useRef(null);

    useEffect(() => {
        // Detect if the content overflows (truncated)
        if (textRef.current) {
            const isOverflowing = textRef.current.scrollHeight > textRef.current.clientHeight + 2; // +2 buffer
            setIsTruncated(isOverflowing);
        }
    }, [notes]);

    if (!notes) return null;

    return (
        <Box sx={{ px: 2, mt: 2, mb: 3, width: '100%' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}>
                <Typography
                    ref={textRef}
                    sx={{
                        fontFamily: 'Inter',
                        fontSize: '16px',
                        fontWeight: 400,
                        color: '#10141F66',
                        textAlign: 'left',
                        display: '-webkit-box',
                        WebkitBoxOrient: 'vertical',
                        WebkitLineClamp: 2,
                        overflow: 'hidden',
                        lineHeight: '22px',
                        flex: 1,
                    }}
                >
                    {notes}
                </Typography>

                {isTruncated && (
                    <Button
                        onClick={() => setShowFullText(true)}
                        sx={{
                            height: '25px',
                            borderRadius: '10.08px',
                            backgroundColor: '#000453',
                            color: 'white',
                            boxShadow: 'none',
                            textTransform: 'none',
                            fontFamily: 'Inter',
                            fontWeight: 500,
                            whiteSpace: 'nowrap',
                            minWidth: 'auto',
                            px: 1.5,
                            '&:hover': {
                                backgroundColor: '#000331',
                            },
                        }}
                    >
                        Show more
                    </Button>
                )}
            </Box>

            <Dialog open={showFullText} onClose={() => setShowFullText(false)} maxWidth="sm" fullWidth>
                <DialogContent>
                    <Typography
                        sx={{
                            fontFamily: 'Inter',
                            fontSize: '16px',
                            color: '#000',
                        }}
                    >
                        {notes}
                    </Typography>
                </DialogContent>
            </Dialog>
        </Box>
    );
};

export default WhiteboardNote;
